import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Layout from '../components/Layout';

import Main from '../components/Main';
import PagarMensual from '../components/PagarMensual';
import PagarSemestral from '../components/PagarSemestral';
import PagoAnticipado from '../components/PagoAnticipado';
import Mail from '../components/Mail';
import { GenerarReciboActa } from '../components/components';
import OptionPayment from '../components/OptionPayment';

import {
    Rodado,
    Cementerio,
    Inmuebles,
    Comercio,
    PlanPago,
    Natatorio,
    ResiduosPatogenos,
    RecuperoPlanFederal,
} from '../components/components';

import { Recibo } from '../components/Recibo';
import MostrarRecibo from '../components/MostrarRecibo';
import PagarAnticipadoPrimerSemestre from '../components/PagarAnticipadoPrimerSemestre';
import PagarMensual2026 from '../components/PagarMensual2026';
import { PagoContado50 } from '../components/Recibo50PlanesContado';

const Router = () => {
    return (
        <BrowserRouter>
            <Layout>
                <Switch>
                    <Route exact path="/apps/inmueble" component={Inmuebles} />
                    <Route exact path="/apps/inmueble/rodado" component={Rodado} />
                    <Route exact path="/apps/inmueble/cementerio" component={Cementerio} />
                    <Route exact path="/apps/inmueble/inmuebles" component={Inmuebles} />
                    <Route exact path="/apps/inmueble/comercio" component={Comercio} />
                    <Route exact path="/apps/inmueble/plan-de-pago" component={PlanPago} />
                    <Route exact path="/apps/inmueble/natatorio" component={Natatorio} />
                    <Route exact path="/apps/inmueble/residuos-patogenos" component={ResiduosPatogenos} />
                    <Route exact path="/apps/inmueble/recupero-plan-federal" component={RecuperoPlanFederal} />
                    <Route exact path="/apps/inmueble/pagar-mensual/" component={PagarMensual} />
                    <Route exact path="/apps/inmueble/pagar-mensual-2026/" component={PagarMensual2026} />
                    <Route exact path="/apps/inmueble/pagar-semestral/" component={PagarSemestral} />
                    <Route exact path="/apps/inmueble/pagar-anticipado-primer-semestre/" component={PagarAnticipadoPrimerSemestre} />
                    <Route exact path="/apps/inmueble/pago-anticipado/" component={PagoAnticipado} />
                    <Route exact path="/apps/inmueble/opciones-pago/" component={OptionPayment} />
                    <Route exact path="/apps/inmueble/pago-contado-50-desc/" component={PagoContado50} />
                    <Route exact path="/apps/inmueble/recibo/" component={Recibo} />
                    <Route exact path="/apps/inmueble/mail/" component={Mail} />
                    <Route exact path="/apps/inmueble/generar-recibo-acta/" component={GenerarReciboActa} />
                    <Route exact path="/apps/inmueble/generar-recibo-acta/ver" component={MostrarRecibo} />
                    <Route component={Main} />
                </Switch>
            </Layout>
        </BrowserRouter>
    );
};

export default Router;
